var map = {
	"./anm-card.png": 568,
	"./arrow.png": 569,
	"./btn-blue-m-v2.png": 570,
	"./btn-blue-m.png": 571,
	"./btn-white-m-v2.png": 572,
	"./btn-white-m.png": 573,
	"./dummy-1.png": 574,
	"./eeziepay.svg": 575,
	"./fcl.svg": 576,
	"./fpx-logo.svg": 577,
	"./game-blue.png": 578,
	"./game-img.png": 579,
	"./game-white.png": 580,
	"./global-language.svg": 581,
	"./ifm-logo.svg": 582,
	"./logo-anniversary.png": 583,
	"./logo-christmas.png": 584,
	"./logo-cny-dragon.png": 585,
	"./logo-cny.png": 586,
	"./logo-halloween.png": 587,
	"./logo-merdeka.png": 588,
	"./logo-mooncake.png": 589,
	"./logo-raya.png": 590,
	"./logo-uefa.png": 591,
	"./merchant-logo.png": 96,
	"./modal-bg.jpg": 592,
	"./number-bg.png": 593,
	"./pagcor.svg": 594,
	"./pool-bg.png": 595,
	"./side-bar-bg.png": 596,
	"./tether.svg": 597,
	"./x33-logo-wc.png": 598,
	"./x33-logo.png": 599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;